module.exports = __webpack_public_path__ + "img/forvestglobalcom.c0325cf4.png";